window.Watermark = Component.extend({

    initialize: function() {
        this.name = "Watermark";
    },

    setup: function(container) {
        this.container = container;

        this.listenTo(this.container, "onLoadComplete", this.handleLoadCompleted);
    },

    handleLoadCompleted: function() {
        this.render();
    },

    render: function() {
        var content = this.getContent(this.getData());
        var $wrapper = this.container.dom.append(content);
    },

    getContent: function(data) {
        return Handlebars.templates["components/watermark"](data);
    },

    getData: function() {
        var data = {};

        data.label = LanguageManager.getString("developed_by");
        data.logo = LanguageManager.getString("saffron_logo");

        return data;
    },

});
